import { Controller } from "stimulus";
import { refreshRemoteContent } from "../remote_content";

export default class extends Controller {
  refresh(event) {
    const [data] = event.detail;

    if (window.notyf && data && data.message) {
      window.notyf.success(data.message);
    }

    refreshRemoteContent(this.element);
  }

  failed(event) {
    const [data] = (event && event.detail) || [];
    const message =
      (data && data.message) || "Something went wrong. Please try again.";

    if (window.notyf) {
      window.notyf.error(message);
    }
  }
}
